import React from "react";
import { Button, Stack } from "@mui/material";
import WBTextField from "components/input/WBTextField";
import {  useForm } from "react-hook-form";
import { getCookie, setCookie } from "services/utils/CookieHandler";
import { ApiUrls } from "services/utils/globalVariables";
import useFetch from "services/hooks/useFetch";
import { LoginHeading, LoginLabel } from "components/typography/text";

export default function LoginFormUsername({ setLoading, setStage, loginData, setCode }) {

    const { CheckCode, JwtLogin } = ApiUrls

    const [{}, fetchCode] = useFetch(CheckCode, "post")
    const [{}, fetchJwt] = useFetch(JwtLogin, "post")

    const { handleSubmit, control, setError, clearErrors } = useForm();

    const submitLoginPassword = (data) => {
        setLoading(true)
        const bodyObj = {
            "UserName": loginData,
            "Code": data.Password,
            "LoginMethod": "",
            "PortalId": "0",
            "IsNameRequired": true,
            "IsDynamicPass": true,
            "IsPhoneNumber": false,
            "MergeUsers": false
        }
        setCode(data.Password)
        fetchCode(bodyObj, handleSubmitPassword)
    }

    const handleSubmitPassword = (res) => {
        if(res == "WrongCode") {
            setError("Password", { type: "custom", message: "رمز عبور اشتباه است" })
        } else {
            clearErrors("Password")
        }

        if(res.includes("OK")) {
            fetchJwt({u: loginData, p: document.getElementById("LoginPassword").value}, handleToken)
        }
        setLoading(false)
    }

    const handleToken = (res) => {
        setCookie("loginData", res, 1/24)
        if(getCookie("loginData")) {
            window.location.href = "/"
        }
    }


    return (
        <Stack spacing={2}>
            <LoginHeading>رمز عبور</LoginHeading>
            <LoginLabel>رمز عبور خود را وارد نمائید</LoginLabel>
            <Stack
                component="form"
                onSubmit={handleSubmit(submitLoginPassword)}
            >
                <WBTextField
                    control={control}
                    name="Password"
                    defualtValue=""
                    autoComplete="off"        
                    type="password"                       
                    autoFocus={true}
                    id="LoginPassword"
                />
                <Button sx={{display: "none !important"}} id="SubmitUserPass" type="submit">submitData</Button>
            </Stack>
        </Stack>
    )
}